import { ChevronLeft, ChevronRight } from 'lucide-react';

interface Props {
  page: number;
  perPage: number;
  total: number;
  onChange: (page: number) => void;
}

export function Pagination({ page, perPage, total, onChange }: Props) {
  const totalPages = Math.max(1, Math.ceil(total / perPage));
  const start = total === 0 ? 0 : (page - 1) * perPage + 1;
  const end = Math.min(page * perPage, total);

  return (
    <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between px-4 py-3 bg-white border-t border-gray-200">
      <p className="text-sm text-gray-600 text-center sm:text-left">
        Showing <span className="font-medium">{start.toLocaleString()}</span>–
        <span className="font-medium">{end.toLocaleString()}</span> of{' '}
        <span className="font-medium">{total.toLocaleString()}</span>
      </p>
      <div className="flex items-center justify-center sm:justify-end gap-2">
        <button
          type="button"
          disabled={page <= 1}
          onClick={() => onChange(page - 1)}
          className="inline-flex items-center px-3 py-2 border border-gray-300 rounded-md text-sm text-gray-700 hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed"
        >
          <ChevronLeft className="w-4 h-4 mr-1" aria-hidden />
          Prev
        </button>
        <span className="text-sm text-gray-600">
          Page {page} of {totalPages.toLocaleString()}
        </span>
        <button
          type="button"
          disabled={page >= totalPages}
          onClick={() => onChange(page + 1)}
          className="inline-flex items-center px-3 py-2 border border-gray-300 rounded-md text-sm text-gray-700 hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed"
        >
          Next
          <ChevronRight className="w-4 h-4 ml-1" aria-hidden />
        </button>
      </div>
    </div>
  );
}
